import { render, staticRenderFns } from "./REC.vue?vue&type=template&id=4f2cfbdb&"
import script from "./REC.vue?vue&type=script&lang=js&"
export * from "./REC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports